<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button
        v-b-modal="'pdf-comprobante-traspaso'+idMovimiento"
        variant="info"
        size="sm"
        v-on:click="descargarPdf"
    >
      <font-awesome-icon icon="file"/>
    </b-button>
    <b-modal
        ok-title="Aceptar"
        cancel-title="Cerrar"
        size="xl"
        :id="'pdf-comprobante-traspaso'+idMovimiento" title="Comprobante de la transferencia">
      <iframe :src="pdf" v-if="pdf!= null && movimientoService.loading === false" style="height: 500px; width: 100%"></iframe>
      <div v-else class="text-center">
        <h3>Cargando por favor espere...</h3>
        <b-spinner variant="primary" label="cargando"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";

export default {
  name: "MostrarComprobanteTraspaso",
  props: {
    idMovimiento: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    movimientoService: new MovimientoService(),
    pdf: null
  }),
  methods: {
    descargarPdf() {
      this.movimientoService.getPdfTransferencia(this.idMovimiento).then(pdf => {
        this.pdf = pdf;
      })
    },
  },
   created() {
     this.debug = this.$localStorageService.getDebug();
   }
}
</script>

<style scoped>

</style>